import * as Sentry from "@sentry/react";

const generateReferenceCode = () => {
  return Math.random().toString(36).substring(2, 15);
};

const logError = (error, errorInfo = null) => {
  const referenceCode = generateReferenceCode();
  Sentry.captureException(error, { extra: { ...errorInfo, referenceCode } });
  // console.error(`Error logged with reference code: ${referenceCode}`, error, errorInfo);
  return referenceCode;
};

logError.info = (message, info) => {
  // console.info(message, info);
};

logError.error = (message, error) => {
  // logError(new Error(message), { error });
};

export { logError };
